// division.js - Division problem generator
import { BasicProblem } from './ui.js';
import { getRandomInt } from './utils.js';

export function generateDivisionProblem(): BasicProblem {
    const mode = document.querySelector<HTMLInputElement>('input[name="divisionMode"]:checked')?.value;

    if (mode === 'timesTables') {
        return generateTimesTableDivision();
    } else {
        return generateLongDivision();
    }
}

function generateTimesTableDivision(): BasicProblem {
    // Existing times tables division code remains the same
    const selectedDivisors = [...document.querySelectorAll<HTMLInputElement>('input[name="divisor"]:checked')]
        .map(checkbox => parseInt(checkbox.value));

    if (selectedDivisors.length === 0) {
        selectedDivisors.push(2);
        const checkbox = document.querySelector<HTMLInputElement>('input[name="divisor"][value="2"]');
        if (checkbox) checkbox.checked = true;
    }

    const divisor = selectedDivisors[Math.floor(Math.random() * selectedDivisors.length)];
    const multiplier = getRandomInt(1, 12);
    const dividend = divisor * multiplier;

    return new BasicProblem(
        String(dividend).padStart(4, ' '),
        String(divisor).padStart(4, ' '),
        '÷');
}

function generateLongDivision(): BasicProblem {
    const allowRemainder = (document.getElementById('allowRemainder') as HTMLInputElement).checked;

    // Generate a random divisor (2 digits)
    const divisor = getRandomInt(11, 99);

    // Generate a dividend that's 3-5 digits
    const minDigits = 3;
    const maxDigits = 5;
    const numDigits = getRandomInt(minDigits, maxDigits);

    let dividend;
    if (allowRemainder) {
        // Generate a dividend that will have a remainder
        // We'll first generate a quotient with (numDigits - 1) digits
        // This ensures our final dividend won't exceed numDigits
        const quotient = getRandomInt(
            Math.pow(10, numDigits - 2),  // For 3 digits: 10^1 = 10
            Math.pow(10, numDigits - 1) - 1  // For 3 digits: 10^2 - 1 = 99
        );
        const remainder = getRandomInt(1, divisor - 1);
        dividend = quotient * divisor + remainder;

        // If we somehow exceeded our max digits, try again
        if (String(dividend).length > maxDigits) {
            return generateLongDivision();
        }
    } else {
        // Generate a dividend that divides evenly
        // Same logic as above for controlling digits
        const quotient = getRandomInt(
            Math.pow(10, numDigits - 2),
            Math.pow(10, numDigits - 1) - 1
        );
        dividend = quotient * divisor;

        // If we somehow exceeded our max digits, try again
        if (String(dividend).length > maxDigits) {
            return generateLongDivision();
        }
    }

    return new BasicProblem(
        String(dividend).padStart(4, ' '),
        String(divisor).padStart(4, ' '),
        '÷');
}